import { EChannel } from 'core/model/enums/channel.enum';
import { GET_WHATSAPP_LINK } from './external.constants';

export const Path = {
  // LOGIN
  LOGIN: '/',
  LOGOUT: '/logout',
  LOYALTY_VALIDATION: '/validacion-loyalty',

  // SUPPLYING
  HOME: '/inicio',
  PROMOTIONS: '/promociones',
  CATALOG: '/catalogo',
  CHECKOUT: '/confirmar',
  CHECKOUT_SHIPPING: '/despacho',
  CHECKOUT_PURCHASE: '/compra',
  CHECKOUT_ORDER_SUCCESS: '/compraexitosa',
  SUCCESS: '/success',
  PRODUCT: '/producto',
  SEARCH: '/busqueda',
  STATIC_PAGES: '/paginas',
  SUGGESTED_PRODUCTS_PAGE: '/productosugeridos',

  // STATIC PAGES
  PROMOTIONS_PAGE: '/pagina/promociones',

  // MAINTENANCE
  MAINTENANCE: '/mantenimiento',

  // MY ORDERS
  MY_ORDERS: '/mispedidos',

  // MY SESSION
  MY_SESSION: '/miperfil',

  // DEEPLINKS
  WELCOME: '/bienvenido',

  // WHATSAPP EXTERNAL
  WHATSAPP: (channel: EChannel) => GET_WHATSAPP_LINK(channel),

  // TRAINING EXTERNAL
  TRAINING: (contentOrigin = 'menu') =>
    `https://crecemosjuntos.com.pe/?utm_source=&utm_medium=&utm_campaign=trafico_insuma_&utm_content=${contentOrigin}_insuma_boton`,
  TECH_ASSISTANCE: (contentOrigin = 'menu') =>
    `https://crecemosjuntos.com.pe/asesoria-tecnica/?utm_source=&utm_medium=&utm_campaign=trafico_insuma_&utm_content=${contentOrigin}_insuma_boton`,
};

export const PATHS_WITH_INSTANT_SCROLL = [`${Path.CHECKOUT}${Path.CHECKOUT_PURCHASE}`];
